export const validateAddress = (address) => {
    //const regex = /^[A-Za-z0-9\s,./-]+$/;
    const disallowedCharacters = /[<>[\]{}*]/;
    if (disallowedCharacters.test(address)) {
        return false;
    }
    return true;
};
